import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

// Pages
import LandingPage from "./pages/LandingPage";
import MainNavigation from "./pages/MainNavigation";
import WhatSection from "./pages/WhatSection";
import AboutBrandPage from "./pages/AboutBrandPage";
import ProductPage from "./pages/ProductPage";
import ProductInDetailPage from "./pages/ProductInDetailPage";
import StoreUpkeepPage from "./pages/StoreUpkeepPage";
import ApparelPage from "./pages/ApparelPage";
import AccessoriesPage from "./pages/AccessoriesPage";
import FootwearPage from "./pages/FootwearPage";
import CustomerServicePage from "./pages/CustomerServicePage";
import CRMPage from "./pages/CRMPage";
import StylingPage from "./pages/StylingPage";
import GroomingPage from "./pages/GroomingPage";
import SOPPage from "./pages/SOPPage";
import VMGuidelinesPage from "./pages/VMGuidelinesPage";
import StockRoomPage from "./pages/StockRoomPage";
import EscalationMatrixPage from "./pages/EscalationMatrixPage";
import WhyPage from "./pages/WhyPage";
import WhoPage from "./pages/WhoPage";

// Auth check - simple session-based
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = sessionStorage.getItem('tbh-auth') === 'true';
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return children;
};

function App() {
  return (
    <div className="App min-h-screen bg-[#F8F6F2]">
      <BrowserRouter>
        <AnimatePresence mode="wait">
          <Routes>
            {/* Landing */}
            <Route path="/" element={<LandingPage />} />
            
            {/* Main Navigation */}
            <Route path="/navigation" element={
              <ProtectedRoute>
                <MainNavigation />
              </ProtectedRoute>
            } />
            
            {/* WHAT Section */}
            <Route path="/what" element={
              <ProtectedRoute>
                <WhatSection />
              </ProtectedRoute>
            } />
            
            {/* About The Brand */}
            <Route path="/what/about-brand" element={
              <ProtectedRoute>
                <AboutBrandPage />
              </ProtectedRoute>
            } />
            
            {/* Product Routes */}
            <Route path="/what/product" element={
              <ProtectedRoute>
                <ProductPage />
              </ProtectedRoute>
            } />
            <Route path="/what/product-in-detail" element={
              <ProtectedRoute>
                <ProductInDetailPage />
              </ProtectedRoute>
            } />
            <Route path="/what/product/apparel" element={
              <ProtectedRoute>
                <ApparelPage />
              </ProtectedRoute>
            } />
            <Route path="/what/product/accessories" element={
              <ProtectedRoute>
                <AccessoriesPage />
              </ProtectedRoute>
            } />
            <Route path="/what/product/footwear" element={
              <ProtectedRoute>
                <FootwearPage />
              </ProtectedRoute>
            } />
            
            {/* Training Modules */}
            <Route path="/what/customer-service" element={
              <ProtectedRoute>
                <CustomerServicePage />
              </ProtectedRoute>
            } />
            <Route path="/what/crm" element={
              <ProtectedRoute>
                <CRMPage />
              </ProtectedRoute>
            } />
            <Route path="/what/styling" element={
              <ProtectedRoute>
                <StylingPage />
              </ProtectedRoute>
            } />
            <Route path="/what/grooming" element={
              <ProtectedRoute>
                <GroomingPage />
              </ProtectedRoute>
            } />
            <Route path="/what/sop" element={
              <ProtectedRoute>
                <SOPPage />
              </ProtectedRoute>
            } />
            <Route path="/what/vm-guidelines" element={
              <ProtectedRoute>
                <VMGuidelinesPage />
              </ProtectedRoute>
            } />
            <Route path="/what/store-upkeep" element={
              <ProtectedRoute>
                <StoreUpkeepPage />
              </ProtectedRoute>
            } />
            <Route path="/what/stock-room" element={
              <ProtectedRoute>
                <StockRoomPage />
              </ProtectedRoute>
            } />
            <Route path="/what/escalation-matrix" element={
              <ProtectedRoute>
                <EscalationMatrixPage />
              </ProtectedRoute>
            } />
            
            {/* WHY Section */}
            <Route path="/why" element={
              <ProtectedRoute>
                <WhyPage />
              </ProtectedRoute>
            } />
            
            {/* WHO Section */}
            <Route path="/who" element={
              <ProtectedRoute>
                <WhoPage />
              </ProtectedRoute>
            } />
            
            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AnimatePresence>
      </BrowserRouter>
    </div>
  );
}

export default App;
